import { getLlmProviderOffersQuery, getPersonasQuery } from "../../graphql/queries";
import { GetLlmProviderOffersQuery, GetLlmProviderOffersQueryVariables, GetPersonasQuery, GetUsageQueryVariables } from "../../graphql/types";
import { useGraphql } from "./graphqlClient";

export type Persona = Omit<NonNullable<GetPersonasQuery["chat"]["personas"]>[0], "__typename">;

let cachedPersonas: GetPersonasQuery | null = null;
export function usePersonas(): { result: GetPersonasQuery | null } {
    if (cachedPersonas) return { result: cachedPersonas };
    const result = useGraphql<GetPersonasQuery, GetUsageQueryVariables>("GetPersonas", getPersonasQuery, {});
    if (result.result) cachedPersonas = result.result;
    return result;
}

export type LlmProviderOffer = Omit<NonNullable<GetLlmProviderOffersQuery["chat"]["providers"]>[0], "__typename">;

let cachedProviderOffers: GetLlmProviderOffersQuery | null = null;
export function useLlmProviderOffers(): { result: GetLlmProviderOffersQuery | null } {
    const hasCache = !!cachedProviderOffers;
    const result = useGraphql<GetLlmProviderOffersQuery, GetLlmProviderOffersQueryVariables>("GetLlmProviderOffers", getLlmProviderOffersQuery, {}, { skip: hasCache });
    if (result.result) cachedProviderOffers = result.result;
    //console.log("get provider offers", result?.result)
    return result.result ? result :  { result: cachedProviderOffers };
}
